export const AmbientOrb = {
  position: 'fixed',
  width: 'H',
  height: 'H',
  borderRadius: '50%',
  background: 'cyber',
  opacity: '.3',
  filter: 'blur(120px)',
  pointerEvents: 'none',
  zIndex: '0',
  top: '20%',
  left: '60%',
  animation: 'orbFloat 20s ease-in-out infinite',
}

export const AmbientOrbSecondary = {
  position: 'fixed',
  width: 'G',
  height: 'G',
  borderRadius: '50%',
  background: 'neon',
  opacity: '.2',
  filter: 'blur(100px)',
  pointerEvents: 'none',
  zIndex: '0',
  top: '60%',
  left: '20%',
  animation: 'orbFloat 25s ease-in-out infinite reverse',
}
